document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('baza-wiedzy-suggested-tiles');
  if (!container || !('geolocation' in navigator)) return;

  navigator.geolocation.getCurrentPosition(
    async ({ coords }) => {
      const params = new URLSearchParams({
        action: 'baza_wiedzy_suggested_ajax',
        security: baza_wiedzy_suggested.nonce,
        lat: coords.latitude,
        lng: coords.longitude,
      });

      try {
        const res = await fetch(baza_wiedzy_suggested.ajax_url, { method: 'POST', body: params });
        const json = await res.json();

        if (json.success && json.data.html_data) {
          const parser = new DOMParser();
          const articles = parser
            .parseFromString(json.data.html_data, 'text/html')
            .body.querySelectorAll('article');

          if (articles.length > 0) {
            container.innerHTML = '';
            for (const article of articles) container.appendChild(article);
          }
        }
      } catch (err) {
        console.error('[Baza wiedzy suggested] Error:', err);
      }
    },
    () => {
      // Permission denied or unavailable — keep server-rendered random tiles
    }
  );
});
